<template>
    <div class="vertical-accordion">
        <div class="vertical-accordion-step"
            v-for="(attributeOptions, attributeIndex, index) in variationAttributeGroups" :key="index">
            <div class="title" @click="toggleStep(index)">
                <div><b>Step {{ index + 1 }}:</b> Choose your {{ attributeIndex }}</div>
                <div class="right" v-if="isOptionSelected(index)"><span class="selected">{{ getOptionName(index)
                        }}</span><i class="icon fas fa-check"></i></div>
            </div>
            <ul v-show="isStepOpen(index)">
                <li v-for="(option, key) in attributeOptions" :key="key"
                    @click="!isOptionDisabled(attributeIndex, option.id) && selectOption(index, option)"
                    :class="{ 'disabled': isOptionDisabled(attributeIndex, option.id) }">
                    <img v-if="option && option.media && option.media.length !== 0"
                        :src="option.media[0].conversionUrls.icon" :alt="option.name + ' image'" />
                    {{ option.name }}
                </li>
            </ul>
        </div>
        <div class="vertical-accordion-step">
            <div class="title">
                <div><b>Step {{ Object.keys(variationAttributeGroups).length + 1 }}:</b> Choose your Pack Size</div>
            </div>
            <div v-if="showLastStep">
                <div class="options">
                    <div class="options__box">
                        <input id="know-dimensions" type="radio" :value="true" name="dimension"
                            v-model="dimensionChoice">
                        <label class="options__box-label " :class="{ 'active': dimensionChoice === true }"
                            for="know-dimensions">I know my dimensions</label>
                    </div>
                    <div class="options__box">
                        <input id="dont-know-dimensions" type="radio" :value="false" name="dimension"
                            v-model="dimensionChoice">
                        <label class="options__box-label" :class="{ 'active': dimensionChoice === false }"
                            for="dont-know-dimensions">I don't know my dimensions</label>
                    </div>
                </div>
                <div class="calculator" v-if="dimensionChoice == true">
                    <product-variations-calculator :product="product" :selected-options="selectedOptions" />
                </div>
                <div class="variations" v-else-if="dimensionChoice == false">
                    <div class="variations__box" v-for="(variation, key) in working_variations" data-aos="flip-down"
                        :data-aos-delay="key * 150">
                        <input :id="'variation_' + variation.id" type="radio" name="selected_variation"
                            v-model="selected_variation" :value="variation">
                        <div class="variations__box-label" :class="{ active: selected_variation.id === variation.id }"
                            :for="'variation_' + variation.id" @click="selectVariation(variation.id)">
                            <div class="variations__box-left">
                                <div class="name">{{ variation.name }}</div>
                                <div class="coverage"
                                    v-if="variation.coverage > 0 && variation.product['use_per_meter_pricing'] == 0">
                                    Coverage: {{ variation.coverage }}m<sup>2</sup>
                                    <span
                                        v-if="variation.product.calculator_type == 'combo_volume' || variation.product.calculator_type == 'single_volume'">based
                                        on a depth of {{ aggregate_depth }}cm</span>
                                </div>
                            </div>
                            <div class="variations__box-right"
                                v-if="variation.product['use_per_meter_pricing'] == 1 && variation.is_sample == false">
                                <div class="price">
                                    From
                                    {{ format_currency(addVat(variation.pricedata['selling_from_price']))
                                    }}<sup>*</sup>
                                    per m<sup><small>2</small></sup>
                                </div>
                                <div class="coverage">
                                    <span style="font-size: 0.8em; display: block; padding-top: 0.5em;">when you buy
                                        {{ variation.coverage }}m<sup>2</sup>&nbsp; or more</span>
                                </div>
                            </div>
                            <div class="variations__box-right" v-else>
                                <div class="price">
                                    {{ format_currency(addVat(variation.pricedata['selling_price'])) }}<sup>*</sup>
                                </div>
                                <div class="coverage"
                                    v-if="product.show_equivalent_price && variation.pricedata['variation_equivalent_m2'] > 0">
                                    <span class="equivalent">{{
                format_currency(addVat(variation.pricedata['variation_equivalent_m2']))
            }}<sup>*</sup>
                                        per m<sup><small>2</small></sup></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="dimensionChoice == true || dimensionChoice == false">* price includes VAT.</p>
            </div>
        </div>
        <div class="vertical-accordion-step" v-if="product.buyable && dimensionChoice == false">
            <div>
                <div class="price_and_quantity" v-if="Object.keys(selected_variation).length > 0">
                    <span class="calculated_price">
                        {{ format_currency(calculated_price) }}<sup>*</sup>
                    </span>
                    <span class="quantity_control" v-if="Object.keys(selected_variation).length > 0">
                        <button type="button"
                            @click="adjustQty(selected_variation.tile_area > 0 ? 0 - selected_variation.tile_area : -1)"
                            class="decrease"><i class="fal fa-fw fa-minus"></i></button>
                        <input type="number"
                            :min="product.use_per_meter_pricing ? (selected_variation.tile_area > 0 ? selected_variation.tile_area : '0.01') : '1'"
                            max="1000"
                            :step="product.use_per_meter_pricing ? (selected_variation.tile_area > 0 ? selected_variation.tile_area : '0.01') : '1'"
                            name="quantity" class="quantity" v-model="quantity" v-on:keydown.enter.prevent>
                        <span class="meter" v-if="product.use_per_meter_pricing">m<sup><small>2</small></sup></span>
                        <button type="button"
                            @click="adjustQty(selected_variation.tile_area > 0 ? selected_variation.tile_area : 1)"
                            class="increase"><i class="fal fa-fw fa-plus"></i></button>
                    </span>
                </div>
            </div>
        </div>
        <div class="vertical-accordion-block" v-if="dimensionChoice == false || dimensionChoice == null">
            <div class="pp_add_to_basket">
                <input type="hidden" name="variation_id" :value="selected_variation.id">
                <button :disabled="Object.keys(this.selected_variation).length === 0" type="submit"
                    class="button wide solid upper" @click.prevent="addMulitpleToBasket"><i
                        class="fal fa-fw fa-shopping-basket"></i> Add To Basket</button>
            </div>
        </div>
        <div class="vertical-accordion-block" v-if="!product.show_loose_load_box && show_qty_alert">
            <p class="pp_qty_alert warning">
                <i class="fal fa-exclamation-circle fa-3x"></i>
                <span v-html="this.qtyAlertContent"></span>
            </p>
        </div>
        <div class="vertical-accordion-block">
            <div class="paypal_pay-later">
                <div class="image"><img src="/images/paypal.svg" alt="PayPal Buy Now Pay Later"></div>
                <div class="text">
                    <p>Buy Now Pay later. Pay in 30 days <span>18+, T&Cs apply, Credit subject to status.</span></p>
                </div>
            </div>
            <div v-if="samples && samples.length > 0">
                <p class="title"><b>Try before you buy. Order multiple FREE samples today</b></p>
                <div class="variations__box">
                    <div class="variations__box-label">
                        <div class="variations__box-left">
                            <div class="name">SAMPLE</div>
                            <small>Samples are FREE OF CHARGE except for the cost of packaging and postage.
                                <template v-if="product.supplier.allow_sample_discount">
                                    Customers will have their delivery charge refunded against their full order at the
                                    point of purchase.
                                </template>
                            </small>
                        </div>
                        <div class="variations__box-right">
                            <div class="price">
                                {{ format_currency(addVat(0.00)) }}<sup>*</sup>
                            </div>
                        </div>
                        <div class="variations__box-select">
                            <span class="select_wrapper">
                                <select class="styled_select" v-model="selected_sample">
                                    <option value="">Select a sample type</option>
                                    <option v-for="item in samples" v-bind:value="item">{{ mapDisplayAttributes(item) }}
                                    </option>
                                </select>
                            </span>
                        </div>
                    </div>
                    <div class="variations__box-basket">
                        <button   :class="{ 'disabled': selected_sample == '' }" @click.prevent="addToBasket(selected_sample)" type="button"
                            class="button solid upper green">Add&nbsp;To
                            <br>Basket</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';
import ProductVariationsCalculator from './ProductVariationsCalculator.vue';
export default {
    components: {
        ProductVariationsCalculator
    },
    directives: {
        debounce
    },
    props: {
        variationAttributeGroups: {
            type: [Array, Object],
            default: () => ({}),
            required: true,
        },
        qtyAlertContent: {
            type: String,
            default: () => (''),
            required: true,
        },
        preselectedVariation: {
            type: String,
            default: () => (''),
            required: false,
        },
        looseLoadContent: {
            type: String,
            default: () => (''),
            required: true,
        },
        product: {
            type: [Array, Object],
            default: () => ({}),
            required: true,
        }
    },
    data() {
        return {
            selectedOptions: [],
            working_product: {},
            variations: [],
            samples: [],
            selected_sample: '',
            working_variations: {},
            selected_variation: {},
            attributeGroups: {},
            currentStep: 0,
            show_qty_alert: false,
            quantity: 1,
            showLastStep: false,
            dimensionChoice: null,
            tiles_required: 0,
            area_coverage: 0,
            coverage_required: 0,
            openSteps: [],
            disabledOptions: {}
        };
    },
    computed: {
        aggregate_depth: function(){
			return process.env.MIX_DEPTH
		},
        calculated_price: function () {
            if (Object.keys(this.selected_variation).length > 0) {
                if (this.selected_variation.product['use_per_meter_pricing'] == 1 && this.selected_variation.is_sample == false) {
                    if ((+this.quantity) < this.selected_variation.coverage) {
                        return (
                            this.addVat(this.selected_variation.pricedata['product_portion'])
                            * (+this.quantity)
                        ) + this.addVat(this.selected_variation.pricedata['delivery_portion']);
                    } else {
                        return this.addVat(this.selected_variation.pricedata['selling_from_price']) * (+this.quantity);
                    }
                } else {
                    return this.addVat(this.selected_variation.pricedata['selling_price']) * (+this.quantity);
                }
            } else {
                return 0;
            }
        }
    },
    created() {
        if (this.preselectedVariation != null && this.preselectedVariation != "") {
            this.getPreSelect();
        }
    },
    mounted() {
        this.getSamples();
        this.attributeGroups = this.variationAttributeGroups;
        if (this.attributeGroups && Object.keys(this.attributeGroups).length > 0) {
            this.openSteps = [0];
        }
    },
    watch: {
        quantity: debounce(function (value) {
            value = parseFloat(Number(value).toFixed(2));
            if (!this.product.use_per_meter_pricing) {
                if (!Number.isInteger(+value)) {
                    this.quantity = Math.floor(+value).toFixed(0);
                } else {
                    this.quantity = (+value).toFixed(0);
                }
            }
            this.quantityCheck();
            this.checkStockAlert();
            this.selected_variation.qty = this.quantity;
        }, 200),
        dimensionChoice(val) {
            this.selected_variation = {};
            if (val == false) {
                this.getVariations();
            }
        }
    },
    methods: {
        mapDisplayAttributes(item) {
            const attributes = item.attributes.map(attribute => attribute.name).join(' - ');
            return `${item.product.name} - ${attributes}`;
        },
        getPreSelect() {
            this.getProduct();
            axios.post('/ajax/getVariations', {
                product_id: this.product.id,
                options: this.selectedOptions,
                has_calculator: true
            }).then((response) => {
                this.working_variations = response.data;
                for (var i = 0, len = this.product.variations.length; i < len; i++) {
                    if (this.working_variations[i]['sku'].trim() == this.preselectedVariation.trim()) {
                        this.selected_variation = this.product.variations[i];
                        this.selectedOptions = this.selected_variation.attributes.map(attr => ({
                            id: attr.id,
                            name: attr.name
                        }));
                        this.$nextTick(function () {
                            if (this.product.use_per_meter_pricing && this.product.variations[i]['is_sample'] == false) {
                                this.quantity = this.selected_variation.coverage;
                                this.quantityCheck();
                            }
                        });
                        break;
                    }
                }
                this.showLastStep = true;
                this.dimensionChoice = false;
                this.openSteps = [];
            });
        },
        getProduct() {
            axios.post('/ajax/getProduct', {
                product_id: this.product.id,
            }).then((response) => {
                this.working_product = response.data;
            });
        },
        getSamples() {
            axios.post('/ajax/getProductSamples', {
                product_id: this.product.id,
            }).then((response) => {
                if (response.data) {
                    this.samples = response.data.variations;
                }
            });
        },
        getVariations() {
            axios.post('/ajax/getVariations', {
                product_id: this.product.id,
                options: this.selectedOptions,
                has_calculator: true
            }).then((response) => {
                this.working_variations = response.data;
                this.selected_variation = response.data[0];
                this.selected_variation.qty = this.quantity;
            });
        },
        getProductAttributes() {
            axios.post('/ajax/getProductAttributes', {
                product_id: this.product.id,
                selectedOptions: this.selectedOptions
            }).then((response) => {
                this.attributeGroups = response.data;
                this.disableOptions();
            });
        },
        checkStockAlert() {
            if (this.selected_variation.qty_alert_point != null && this.quantity >= this.selected_variation.qty_alert_point) {
                this.show_qty_alert = true;
            } else {
                this.show_qty_alert = false;
            }
        },
        selectVariation(variationId) {
            const selectedVariation = this.working_variations.find(variation => variation.id === variationId);
            if (selectedVariation) {
                this.selected_variation = selectedVariation;
                this.selected_variation.qty = this.quantity;
            }
        },
        isOptionSelected(attributeIndex) {
            return this.selectedOptions[attributeIndex] !== undefined;
        },
        getOptionName(attributeIndex) {
            const selectedOption = this.selectedOptions[attributeIndex];
            return selectedOption ? selectedOption.name : '';
        },
        ...mapActions(['minicartRefresh']),
        adjustQty: function (qty) {
            var newQty = Number(this.quantity) + Number(qty);

            if (newQty < (Number(this.selected_variation.tile_area) > 0 ? Number(this.selected_variation.tile_area) : 1)) {
                newQty = (Number(this.selected_variation.tile_area) > 0 ? Number(this.selected_variation.tile_area) : 1);
            };
            this.quantity = parseFloat(newQty.toFixed(2));
        },
        addToBasket(variation) {
            this.selected_variation = variation;
            if ((this.quantity < 1 && this.product.use_per_meter_pricing == 0) || (this.quantity < 0 && this.product.use_per_meter_pricing == 1)) {
                alert('You must set a quantity');
                return false;
            }
            axios.post('/box/basket/add', {
                Model_Type: '\\App\\Variation',
                Model_Id: this.selected_variation.id,
                Quantity: this.quantity,
                FreeTypeAttributes: ''
            }).then((response) => {
                this.$store.commit('updateMinicartRefreshStatus', true);
                this.added_popup(this.product.name + ' - ' + variation.name.toUpperCase());
            });
        },
        addMulitpleToBasket() {
            if ((this.quantity < 1 && this.product.use_per_meter_pricing == 0) || (this.quantity < 0 && this.product
                .use_per_meter_pricing == 1)) {
                alert('You must set a quantity');
                return false;
            }

            var variations = [];
            variations.push(this.selected_variation);
            axios.post('/ajax/addMultipleToBasket', {
                variations: variations
            }).then((response) => {
                this.$store.commit('updateMinicartRefreshStatus', true);
                var popup_text;
                for (var i = 0, len = this.working_variations.length; i < len; i++) {
                    if (this.working_variations[i]['id'] === this.selected_variation.id) {
                        this.working_variations[i]['in_basket'] = this.working_variations[i]['in_basket'] +
                            this.quantity;
                        if (this.working_variations.length > 1) {
                            popup_text = this.working_variations[i].name;
                        } else {
                            popup_text = this.product.name;
                        }
                        break;
                    }
                }

                var pos = popup_text.lastIndexOf(',');
                if (pos > 0) {
                    popup_text = popup_text.substring(0, pos) + ' and ' + popup_text.substring(pos + 1)
                }
                this.added_popup(popup_text);
            });
        },
        popup(message) {
            $.alert({
                title: '',
                content: message,
                buttons: {
                    Basket: {
                        text: 'Continue',
                        btnClass: 'btn-green',
                    }
                }
            });

        },
        added_popup: function (item) {
            $.alert({
                title: 'Great!',
                content: '<b>' + item + '</b> added to your basket.',
                buttons: {
                    Continue: {
                        text: 'Continue Shopping',
                    },
                    Basket: {
                        text: 'View Basket',
                        btnClass: 'btn-green',
                        action: function () {
                            window.location.href = '/basket'
                        }
                    }
                }
            });
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        format_number: function (value) {
            return this.numberWithCommas((Math.round((value + 0.0001) * 100) / 100).toFixed(2));
        },
        format_currency(value) {
            return "£" + this.numberWithCommas((Math.round((value + 0.0001) * 100) / 100).toFixed(2));
        },
        addVat(num) {
            var rate = process.env.MIX_VAT_RATE;
            var multiply_by = 1 + (rate / 100);
            return parseFloat((num * multiply_by).toFixed(2));
        },
        quantityCheck(autoset = true) {
            if (this.selected_variation.is_sample == false && this.selected_variation.product.use_per_meter_pricing == 1 && this.selected_variation.dimension_x > 0 && this.selected_variation.dimension_y > 0) {
                var tile_coverage = (this.selected_variation.dimension_x / 1000) * (this.selected_variation.dimension_y / 1000);
                var tiles_required = parseFloat(this.quantity / tile_coverage).toFixed(2);
                this.tiles_required = tiles_required;
                this.area_coverage = parseFloat((Math.floor(tiles_required) * tile_coverage).toFixed(2));
                if (this.area_coverage < this.quantity) {
                    this.coverage_required = parseFloat(((Math.floor(tiles_required) + 1) * tile_coverage));
                } else {
                    this.coverage_required = this.area_coverage;
                }
                if (autoset == true) { this.quantity = this.coverage_required; this.quantityCheck(false); }
            } else {
                this.area_coverage = 0;
                this.tiles_required = 0;
                this.coverage_required = 0;
            }
        },
        toggleStep(index) {
            // Close all open steps
            this.openSteps = [];

            if (index > 0) {
                const previousStepIndex = index - 1;
                if (!this.selectedOptions[previousStepIndex]) {
                    alert('Please select an option for Step ' + (previousStepIndex + 1) +
                        ' before proceeding to Step ' + (index + 1) + '.');
                    return;
                }
            }

            this.selectedOptions.splice(index);

            this.getProductAttributes();
            if (this.openSteps.includes(index)) {
                this.openSteps = this.openSteps.filter(step => step !== index);
            } else {
                this.openSteps.push(index);
            }
        },
        isStepOpen(stepIndex) {
            return this.openSteps.includes(stepIndex);
        },
        selectOption(index, option) {

            if (index == 0) {
                this.disabledOptions = {};
                this.selectedOptions = [];
            }
            // Get latest Attributes & Update
            this.getProductAttributes();

            this.working_variations = [];
            this.dimensionChoice = null;
            this.selected_variation = {};

            if (!this.selectedOptions[index]) {
                this.selectedOptions[index] = [];
            }
            this.selectedOptions[index] = option;

            this.currentStep = index + 1;
            if (this.currentStep < Object.keys(this.attributeGroups).length) {
                this.openSteps.push(this.currentStep);
            } else {
                this.showLastStep = true;
            }

            const previousStepIndex = index;
            if (previousStepIndex >= 0 && this.openSteps.includes(previousStepIndex)) {
                this.openSteps = this.openSteps.filter(step => step !== previousStepIndex);
            }
        },
        disableOptions() {
            const disabledOptions = {};

            const variationGroupNames = Object.keys(this.variationAttributeGroups);
            const attributeGroupNames = Object.keys(this.attributeGroups);

            // Find the common groups between variationAttributeGroups and attributeGroups
            const commonGroups = variationGroupNames.filter(groupName => attributeGroupNames.includes(groupName));

            // Exclude the first index
            const commonGroupsExcludingFirst = commonGroups.slice(1);

            for (let groupName of commonGroupsExcludingFirst) {

                const variationAttributeValues = this.variationAttributeGroups[groupName];
                const attributeValues = Array.isArray(this.attributeGroups[groupName]) ? this.attributeGroups[groupName] : [];

                // Compare the attribute values and find the disabled options
                const disabledOptionsForGroup = variationAttributeValues.filter(variationValue => {
                    return !attributeValues.some(attributeValue => attributeValue.id === variationValue.id);
                });

                disabledOptions[groupName] = disabledOptionsForGroup;
            }

            this.disabledOptions = disabledOptions;
        },
        isOptionDisabled(groupName, optionId) {
            if (this.disabledOptions[groupName]) {
                return this.disabledOptions[groupName].some(option => option.id === optionId);
            } else {
                return false;
            }
        }
    }
};
</script>
